import Axios from "axios";
import axios, { getEnv } from "../../../../../services/api";

interface AtendimentosSSEServiceInterface {
  findAll: (
    params: any,
    body?: Record<string, any>,
    controller?: AbortController
  ) => Promise<any>;
  findAllGerencial: (
    params: any,
    body?: Record<string, any>,
    controller?: AbortController
  ) => Promise<any>;
  findAllQtdAgente: (
    params: any,
    body?: Record<string, any>,
    controller?: AbortController
  ) => Promise<any>;
  findAllDescartados: (
    params: any,
    body?: Record<string, any>,
    controller?: AbortController
  ) => Promise<any>;
  findAllTreinamento: (
    params: any,
    body?: Record<string, any>,
    controller?: AbortController
  ) => Promise<any>;
  findAllConsolidado: (
    params: any,
    body?: Record<string, any>,
    controller?: AbortController
  ) => Promise<any>;
  findAllRecusado: (
    params: any,
    body?: Record<string, any>,
    controller?: AbortController
  ) => Promise<any>;
  findRelatorioRecusado: (
    params: any,
    body?: Record<string, any>,
    controller?: AbortController
  ) => Promise<any>;
  getFilterOptions: (controller?: AbortController) => Promise<any>;
  getLastSignature: (id: string, controller?: AbortController) => Promise<any>;
  getFilterCanaisDigitais: (
    uf: string,
    dataInicio: string,
    dataFim: string,
    controller?: AbortController
  ) => Promise<any>;
  getFilterSolucoes: (
    uf: string,
    dataInicio: string,
    dataFim: string,
    controller?: AbortController
  ) => Promise<any>;
  getFilterRegionais: (
    uf: string,
    dataInicio: string,
    dataFim: string,
    controller?: AbortController
  ) => Promise<any>;
  getFilterAcoes: (
    uf: string,
    dataInicio: string,
    dataFim: string,
    controller?: AbortController
  ) => Promise<any>;
  getFilterOptionsConsolidado: (controller?: AbortController) => Promise<any>;
  searchInput: (
    body: Record<string, any>,
    params: any,
    controller?: AbortController
  ) => Promise<any>;
  attendanceGeoReport: (
    body?: Record<string, any>,
    params?: any,
    controller?: AbortController
  ) => Promise<any>;
  getAtendimentosOpcoesPorUf: (
    ufId: string,
    controller?: AbortController
  ) => Promise<any>;
}

export const AtendimentosSSEService: AtendimentosSSEServiceInterface = {
  findAll: async (params, body = {}, controller) => {
    try {
      //@ts-ignore
      const response = await axios.post(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/nan/relatorio-atendimentos`,
        body,
        {
          params,
          signal: controller,
        }
      );
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        console.log("Requisição cancelada: Gerencial");
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },

  findAllGerencial: async (params, body = {}, controller) => {
    try {
      //@ts-ignore
      const response = await axios.post(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/nan/atendimentos`,
        body,
        {
          params,
          signal: controller,
        }
      );
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        //@ts-ignore
        console.log("Requisição cancelada", error.message);
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },
  findAllQtdAgente: async (params, body = {}, controller) => {
    try {
      //@ts-ignore
      const response = await axios.post(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/nan/relatorio-atendente`,
        body,
        {
          params,
          signal: controller,
        }
      );
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        console.log("Requisição cancelada: Qtd Agente");
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },
  findAllDescartados: async (params, body = {}, controller) => {
    try {
      //@ts-ignore
      const response = await axios.post(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/nan/relatorio-inativo`,
        body,
        {
          params,
          signal: controller,
        }
      );
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        console.log("Requisição cancelada: Descartados");
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },
  findAllTreinamento: async (params, body = {}, controller) => {
    try {
      //@ts-ignore
      const response = await axios.post(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/nan/atendimentos-treinamento`,
        body,
        {
          params,
          signal: controller,
        }
      );
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        console.log("Requisição cancelada Testadores");
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },
  findAllConsolidado: async (params, body = {}, controller) => {
    try {
      //@ts-ignore
      const response = await axios.post(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/nan/relatorio-consolidado`,
        body,
        {
          params,
          signal: controller,
        }
      );
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        console.log("Requisição cancelada Consolidado");
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },
  findAllRecusado: async (params, body = {}, controller) => {
    try {
      //@ts-ignore
      const response = await axios.post(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/nan/recusado`,
        body,
        {
          params,
          signal: controller,
        }
      );
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        //@ts-ignore
        console.log("Requisição cancelada", error.message);
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },
  findRelatorioRecusado: async (params, body = {}, controller) => {
    try {
      //@ts-ignore
      const response = await axios.post(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/nan/relatorio-atendimento-recusado`,
        body,
        {
          params,
          signal: controller,
        }
      );
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        console.log("Requisição cancelada: Recusado");
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },

  getFilterOptions: async (controller) => {
    try {
      //@ts-ignore
      const response = await axios.get(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/nan/atendimentos/opcoes?consulta=true`,
        { signal: controller }
      );
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        console.log("Requisição cancelada: Filtros Gerencial");
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },

  getLastSignature: async (id, controller) => {
    try {
      //@ts-ignore
      const response = await axios.get(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/nan/ultima-assinatura?idNan=${id}`,
        { signal: controller }
      );
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        console.log("Requisição cancelada");
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },

  getFilterCanaisDigitais: async (uf, dataInicio, dataFim, controller) => {
    let url = `${await getEnv(
      "REACT_APP_URL_SERVICE"
    )}/v1/nan/opcoes/canais-digitais?`;

    if (uf) {
      url += `siglaUf=${uf}`;
    }

    if (dataInicio) {
      url += `&dataInicio=${encodeURIComponent(dataInicio)}`;
    }
    if (dataFim) {
      url += `&dataFim=${encodeURIComponent(dataFim)}`;
    }

    try {
      //@ts-ignore
      const response = await axios.get(url, { signal: controller });
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        console.log("Requisição cancelada");
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },

  getFilterSolucoes: async (uf, dataInicio, dataFim, controller) => {
    let url = `${await getEnv(
      "REACT_APP_URL_SERVICE"
    )}/v1/nan/opcoes/solucoes?`;

    if (uf) {
      url += `siglaUf=${uf}`;
    }

    if (dataInicio) {
      url += `&dataInicio=${encodeURIComponent(dataInicio)}`;
    }
    if (dataFim) {
      url += `&dataFim=${encodeURIComponent(dataFim)}`;
    }

    try {
      //@ts-ignore
      const response = await axios.get(url, { signal: controller });
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        console.log("Requisição cancelada");
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },

  getFilterRegionais: async (uf, dataInicio, dataFim, controller) => {
    let url = `${await getEnv(
      "REACT_APP_URL_SERVICE"
    )}/v1/nan/opcoes/regionais?`;

    if (uf) {
      url += `siglaUf=${uf}`;
    }

    if (dataInicio) {
      url += `&dataInicio=${encodeURIComponent(dataInicio)}`;
    }
    if (dataFim) {
      url += `&dataFim=${encodeURIComponent(dataFim)}`;
    }

    try {
      //@ts-ignore
      const response = await axios.get(url, { signal: controller });
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        console.log("Requisição cancelada");
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },

  getFilterAcoes: async (uf, dataInicio, dataFim, controller) => {
    let url = `${await getEnv("REACT_APP_URL_SERVICE")}/v1/nan/opcoes/acoes?`;

    if (uf) {
      url += `siglaUf=${uf}`;
    }

    if (dataInicio) {
      url += `&dataInicio=${encodeURIComponent(dataInicio)}`;
    }
    if (dataFim) {
      url += `&dataFim=${encodeURIComponent(dataFim)}`;
    }

    try {
      //@ts-ignore
      const response = await axios.get(url, { signal: controller });
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        console.log("Requisição cancelada");
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },

  getFilterOptionsConsolidado: async (controller) => {
    try {
      //@ts-ignore
      const response = await axios.get(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/nan/relatorio-consolidado/opcoes`,
        { signal: controller }
      );
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        console.log("Requisição cancelada: Filtro Consolidado");
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },

  searchInput: async (body, params, controller) => {
    try {
      //@ts-ignore
      const response = await axios.post(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/atendimentos-sas/tipos/consultar`,
        body,
        {
          params,
          signal: controller,
        }
      );
      return response.data;
    } catch (error) {
   if (Axios.isCancel(error)) {
        console.log("Requisição cancelada");
      } else {
        //@ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },

  attendanceGeoReport: async (body = {}, params, controller) => {
    console.log("attendanceGeoReport", body);
    try {
      //@ts-ignore
      const response = await axios.post(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/integracao/prix/attendance-geo-report`,
        body,
        { params, signal: controller }
      );
      return response.data;
    } catch (error) {
      console.log("error at", error);
      throw error;
    }
  },

  getAtendimentosOpcoesPorUf: async (ufId, controller) => {
    try {
      //@ts-ignore
      const response = await axios.get(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/nan/atendimentos/opcoes/ufs/${ufId}`,
        { signal: controller }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
